export default __webpack_public_path__ + "static/media/input2Cimg.e0a54925.png";